module.exports = __webpack_public_path__ + "static/media/ic_logout.12fa8e4a.svg";